/*
  viral-cookie-prefs.js  (sections/viral-legal-links.liquid)

  Reopens the preferences modal of Shopify's cookie banner from the footer strip, so that withdrawing consent is as
  easy as giving it (AEPD cookie guide, 3.2.9; LSSI art. 22.2). Uses the documented call
  privacyBanner.showPreferences() (shopify.dev/docs/api/customer-privacy). That object is documented for the
  Shopify cookie banner script; whether it exists on an Online Store theme is checked here at runtime and never
  assumed: the control ships hidden and is only revealed when the method is present. Nothing is written, no
  consent is set or read by this file. No user-facing text lives here (the label comes from the section).
*/
(() => {
  const reveal = () => {
    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return false;

    document.querySelectorAll('[data-viral-cookie-prefs]').forEach((button) => {
      if (button.dataset.viralBound) return;
      button.dataset.viralBound = '1';
      button.hidden = false;
      const item = button.closest('[data-viral-cookie-prefs-item]');
      if (item) item.hidden = false;
      button.addEventListener('click', () => {
        try {
          const result = banner.showPreferences();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (error) {
          // the modal could not open: the policies section keeps Shopify's own preferences link
        }
      });
    });
    return true;
  };

  if (reveal()) return;

  // the banner script may load after this one: retry for ten seconds, then give up quietly
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (reveal() || attempts >= 20) window.clearInterval(timer);
  }, 500);
})();
